export default (
  state = {
    dealTableGroupInformation: {},
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Doc Notes Data
    ===============================
    */
    case "UPDATE_DEAL_TABLE_GROUP_INFORMATION":
      return action.payload;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/DocumentDealTableReducer.js